import React from 'react';
import { useSelector } from 'react-redux';

import getDisplayInformation from '../../data-driven-logo/get-display-information';
import DataDrivenLogoColumn from '../../columns/data-driven-logo-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ProviderColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { labelProviderId } = returnConfiguration || {};

  if (!labelProviderId) {
    return '';
  }

  const providerId = Number.parseInt(labelProviderId, 10);
  const displayInformation = getDisplayInformation({ providerId });

  if (!displayInformation) {
    return '';
  }

  return <DataDrivenLogoColumn dataDrivenLogoProps={{ providerId }} message={displayInformation.name} />;
};

export const Provider = {
  getMessageDescriptor: () => messages.provider,
  id: 'provider',

  render: ({ fulfillmentId }) => {
    return <ProviderColumn fulfillmentId={fulfillmentId} />;
  },
};
